<div *ngIf="(vm$ | async) as vm">
  <div class="row">
    <div class="col-xl-5 col-lg-6 col-md-10 col-sm-12 mx-auto mt-lg-5">

      <div *ngIf="workingText" class="text-center">
        <span>{{workingText}}</span>
      </div>

      <div *ngIf="errorText" class="danger text-center">
        <span>{{errorText}}</span>
        <button mdbBtn gradient="blue" size="sm" class="waves-effect waves-light" mdbWavesEffect
          (click)="errorContinue()">Ok</button>
      </div>

      <!-- allow input -->
      <div *ngIf="!workingText && !errorText">

        <!-- token workflow -->
        <div *ngIf="vm.tokenVm as tvm">
          <mdb-card bgColor="login-card" class="wow fadeIn z-depth-1" data-wow-delay="0.3s"
            style="animation-name: none; visibility: visible;">
            <mdb-card-body>

              <!--Header-->
              <div class="form-header blue-gradient">
                <h3>
                  Secure Access
                </h3>
              </div>

              <div *ngIf="!tvm.tokenRequested">
                <span>You can request a secure access code by clicking the button below.</span>
              </div>

              <div *ngIf="tvm.tokenRequested">
                <span>Please check your work cell phone for a text message containing a secure access code to use below.</span>
              </div>

              <!--Body-->
              <div class="md-form" *ngIf="!tvm.userName">
                <mdb-icon fas icon="user" class="white-text"></mdb-icon>
                <input type="text" disabled id="orangeForm-name" class="form-control" mdbInput [(ngModel)]="tvm.userName">
                <label for="orangeForm-name" class="">User Id</label>
              </div>
              <div *ngIf="tvm.tokenRequested" class="md-form">
                <mdb-icon fas icon="lock" class="white-text"></mdb-icon>
                <input type="text" id="orangeForm-pass" class="form-control" mdbInput [(ngModel)]="tvm.password">
                <label for="orangeForm-pass" class="">Token</label>
              </div>

              <div class="text-center">
                <button *ngIf="!tvm.tokenRequested" mdbBtn gradient="blue" size="lg" class="waves-effect waves-light" mdbWavesEffect
                    (click)="tokenRequest(tvm)">Request Access</button>

                <button *ngIf="tvm.tokenRequested" mdbBtn gradient="blue" size="lg" class="waves-effect waves-light" mdbWavesEffect
                  (click)="login(tvm)">Submit Access Code</button>
              </div>

            </mdb-card-body>
          </mdb-card>

        </div>

        <!-- user name / password entry -->
        <div *ngIf="vm.loginVm as lvm">
          <mdb-card bgColor="login-card" class="wow fadeIn z-depth-1" data-wow-delay="0.3s"
            style="animation-name: none; visibility: visible;">
            <mdb-card-body>

              <!--Header-->
              <div class="form-header blue-gradient">
                <h3>
                  <mdb-icon fas icon="user" class="mt-2 mb-2"></mdb-icon> Log in:
                </h3>
              </div>

              <!--Body-->
              <div class="md-form">
                <mdb-icon fas icon="user" class="white-text"></mdb-icon>
                <input type="text" id="orangeForm-name" class="form-control" mdbInput [(ngModel)]="lvm.userName">
                <label for="orangeForm-name" class="">Santa Cruz User Name</label>
              </div>

              <div class="md-form">
                <mdb-icon fas icon="lock" class="white-text"></mdb-icon>
                <input type="password" id="orangeForm-pass" class="form-control" mdbInput [(ngModel)]="lvm.password">
                <label for="orangeForm-pass" class="">Password</label>
              </div>

              <div class="text-center">
                <button mdbBtn gradient="blue" size="lg" class="waves-effect waves-light" mdbWavesEffect
                  (click)="login(lvm)">Login</button>
              </div>

            </mdb-card-body>
          </mdb-card>
        </div>
      </div>

    </div>
  </div>
</div>
